import { render, staticRenderFns } from "./ParcelPreviousDocumentsSection.vue?vue&type=template&id=1578bf20&scoped=true&"
import script from "./ParcelPreviousDocumentsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelPreviousDocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelPreviousDocumentsSection.vue?vue&type=style&index=0&id=1578bf20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578bf20",
  null
  
)

export default component.exports